import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../services/AuthContext';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout, isAuthenticated } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to={isAuthenticated() ? "/dashboard" : "/"} className="logo">
            <div className="logo-icon">🎓</div>
            CertiChain
          </Link>

          <button className="mobile-menu-btn" onClick={toggleMenu}>
            <span className="hamburger"></span>
          </button>

          <nav className={`nav-center ${isMenuOpen ? 'open' : ''}`}>
            <ul className="nav-links">
              <li>
                <Link
                  to="/verify"
                  className={`nav-link ${isActive('/verify')}`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  Verify
                </Link>
              </li>

              <li>
                <Link
                  to="/student-access"
                  className={`nav-link ${isActive('/student-access')}`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  Student Access
                </Link>
              </li>

              {isAuthenticated() && (
                <li>
                  <Link
                    to="/dashboard"
                    className={`nav-link ${isActive('/dashboard')}`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Dashboard
                  </Link>
                </li>
              )}

              {isAuthenticated() && user?.role === 'ADMIN' && (
                <>
                  <li>
                    <Link
                      to="/issue"
                      className={`nav-link ${isActive('/issue')}`}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      Issue Certificate
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/my-certificates"
                      className={`nav-link ${isActive('/my-certificates')}`}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      My Certificates
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </nav>

          <div className={`nav-right ${isMenuOpen ? 'open' : ''}`}>
            {isAuthenticated() && user ? (
              <div className="nav-user">
                <div className="user-info">
                  <span className="user-name">
                    {user.profile?.firstName} {user.profile?.lastName}
                  </span>
                  <span className={`badge badge-${user.role === 'ADMIN' ? 'error' : user.role === 'STUDENT' ? 'success' : 'warning'}`}>
                    {user.role}
                  </span>
                </div>
                <button onClick={handleLogout} className="btn btn-secondary btn-sm">
                  Logout
                </button>
              </div>
            ) : (
              <div className="auth-buttons">
                <Link to="/auth" className="btn btn-ghost">
                  Login
                </Link>
                <Link to="/auth" className="btn btn-primary">
                  Register
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;